/* eslint-disable no-undef */
import HttpClient from './HttpClient'
export const isProd = import.meta.env.NODE_ENV === 'production'
export const isDev = import.meta.env.NODE_ENV === 'development'
/**
 * Backend API base URL
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

/**
 * Public API Client that uses native fetch to connect with the backend API.
 *
 * This is specifically designed for the public app and doesn't include
 * authentication headers since public endpoints don't require auth.
 */
class ApiClient extends HttpClient {
  constructor(baseURL = API_BASE_URL) {
    super({
      baseURL,
      headers: {
        'Content-Type': 'application/json',
        locale: localStorage.getItem('language') || 'en',
      },
      interceptors: {
        request() {
          try {
            const accessToken = localStorage.getItem('jwt')

            if (accessToken) {
              return { headers: { Authorization: `Bearer ${accessToken}` } }
            }
            const twoFAToken = localStorage.getItem('twoFAToken')

            if (twoFAToken) {
              return { headers: { Authorization: `Bearer ${twoFAToken}` } }
            }
          } catch (error) {
            console.error(error)
          }
        },
        async response(res: Response) {
          try {
            // Check if response has content before trying to parse JSON
            const contentType = res.headers.get('content-type')
            const hasJsonContent =
              contentType && contentType.includes('application/json')
            const hasContent = res.status !== 204 && res.status !== 304

            let payload = null
            if (hasJsonContent && hasContent) {
              payload = await res.json()
            }

            if (res.ok) return { ...res, data: payload }

            if (
              res.status === 401 &&
              isProd &&
              !window.location.pathname.includes('2fa')
            ) {
              // logout
              localStorage.removeItem('jwt')
              localStorage.removeItem('user')

              const { href } = window.location

              const from = href.substring(
                href.indexOf(window.location.pathname) - 1
              )

              sessionStorage.setItem('from', from)
              window.location.pathname = `/login`
            }

            // Format backend error to be displayed on the ui
            let errors = payload?.errors ||
              payload?.error ||
              payload || {
                message: `Request failed with status ${res.status}`,
              }

            errors = Array.isArray(errors) ? errors : [errors]

            errors = errors.map((error: any) => {
              if (Array.isArray(error.message)) {
                return {
                  ...error,
                  ...error.message[0],
                  message: error.message[0]?.msg || error.message[0]?.message,
                }
              }

              return error
            })

            return { ...res, errors: Array.isArray(errors) ? errors : [errors] }
          } catch (error) {
            console.error(error)

            return { errors: [error] }
          }
        },
      },
    })
  }
}

export default ApiClient
